import { useMemo } from "react";
import { useAmount } from "./useAmount";
import { ProjectTotalization } from "interfaces/front/business";

export const useSupportAmountPool = (summary: ProjectTotalization | undefined): string | undefined => {
  const supportAmountPool = useMemo(() => {
    if (summary != undefined && summary.support_amount_reserved != null && summary.support_amount != null) {
      const amountPool = summary.support_amount_reserved - summary.support_amount;
      return amountPool > 0 ? amountPool : undefined; // 0円の場合はわざわざ表示させない
    } else {
      return undefined;
    }
  }, [summary]);
  return useAmount(supportAmountPool);
};
